import React, { } from 'react';
import { useDispatch } from 'react-redux';

import { CollectionServer, GET, Model, POST, QueryDetail, QueryOrder, deleteInArray, errorCatch, updateInArray } from 'fennec-ui';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import confirmKey from '../../components/ConfirmKeyModal';
import PageLayout from '../../components/PageLayout';
var _ = require('lodash');

export default function FederationadministratorSettingsMailing(props) {
    const dispatch = useDispatch();
    const { auth } = props;

    const filters = () => [
        {
            label: "Идентификатор",
            name: "ID",
            sort: true,
            filter: true,
        },
        {
            name: "nazvanie",
            sort: true,
            filter: true,
        },
        {
            name: "opisanie",
            sort: true,
            filter: true,
        },
        {
            label: "Дата создания",
            name: "createdAt",
            type: "date",
            sort: true,
            filter: true,
        }
    ];
    const render = (item, idx, { setCollection, setCollectionItem, update }) => {
        return (<div key={idx} style={{ padding: "10px 0px", width: "100%", borderTop: "1px solid #eee" }}>
            <div style={{ display: "flex" }}>
                <div style={{ flex: "1 1 auto" }}>
                    <div style={{ fontWeight: "600" }}>
                        {item.nazvanie}
                    </div>
                    <div>
                        {item.opisanie}
                    </div>
                </div>
                <div style={{ flex: "0 0" }}>

                </div>
            </div>
        </div>)
    }

    // "/api/rassilki/new"
    // "/api/rassilki/update"
    // "/api/rassilki/delete/{id}"
    // "/api/rassilki/get/{id}"
    // "/api/rassilki/list"

    return (
        <PageLayout>
        <div style={{ padding: "15px 10px", backgroundColor: "white" }}>
            <CollectionServer
                name={"Rassilki"}
                auth={auth}
                size="small"

                source={`/api/rassilki/list`}
                filters={filters}

                mode={"list"}
                render={render}

                collectionActions={() => [
                    {
                        action: (values, unlock, close, { collection, setCollection }) => {
                            POST(auth, `/api/rassilki/new`, values,
                                ({ data }) => {
                                    setCollection(updateInArray(collection, data));
                                    close();
                                }, (err) => errorCatch(err, unlock)
                            );
                        },
                        form: Model,
                        meta: [
                            {
                                label: "Форма",
                                name: "forma",
                                type: "object",
                                relation: {
                                    display: (item) => {
                                        return item.nazvanie
                                    },
                                    reference: { object: "FormaRassilki", property: "ID"/*, source: "/api/meropriyatiya/list/com"*/ },
                                    type: "many-one",
                                },
                                queryFilter: [
                                    QueryDetail("model"),
                                    QueryOrder("nazvanie", "ASC")
                                ]
                            },
                            {
                                label: "Название",
                                name: "nazvanie",
                                type: "string",
                            },
                            {
                                label: "Описание",
                                name: "opisanie",
                                type: "text",
                            },
                            {
                                label: "Автоматически подписывать новых пользователей",
                                name: "autoSubscribe",
                                type: "bool",
                            },
                        ],
                        options: {
                            initialValues: {},
                        },
                        title: "Добавить рассылку",
                        modal: {
                            minWidth: "450px",
                            title: "Новая рассылка",
                        }
                    }
                ]}
                modelActions={(item) => [
                    {
                        action: (values, unlock, close, { collection, setCollection }) => {
                            let o = {
                                ID: item.ID,
                                ...values
                            }
                            POST(auth, `/api/rassilki/update`, o,
                                ({ data }) => {
                                    setCollection(updateInArray(collection, data));
                                    close();
                                }, (err) => errorCatch(err, unlock)
                            );
                        },
                        object: item,
                        form: Model,
                        meta: [
                            {
                                label: "Форма",
                                name: "forma",
                                type: "object",
                                relation: {
                                    display: (item) => {
                                        return item.nazvanie
                                    },
                                    reference: { object: "FormaRassilki", property: "ID"/*, source: "/api/meropriyatiya/list/com"*/ },
                                    type: "many-one",
                                },
                                queryFilter: [
                                    QueryDetail("model"),
                                    QueryOrder("nazvanie", "ASC")
                                ]
                            },
                            {
                                label: "Название",
                                name: "nazvanie",
                                type: "string",
                            },
                            {
                                label: "Описание",
                                name: "opisanie",
                                type: "text",
                            },
                            {
                                label: "Автоматически подписывать новых пользователей",
                                name: "autoSubscribe",
                                type: "bool",
                            },
                        ],
                        options: {
                            initialValues: {},
                        },
                        title: "Изменить",
                        modal: {
                            width: "450px",
                            title: <div>
                                <div>Изменить рассылку</div>
                                {/* <div style={{ fontSize: "14px" }}>{object?.nazvanie} {(object?.sezon?.nazvanie) ? "(" + object?.sezon?.nazvanie + ")" : ""}</div> */}
                            </div>
                        }
                    },
                    {
                        title: <span>Подписать всех</span>,
                        action: (values, unlock, close, { collection, setCollection }) => {
                            confirmKey({
                                pass: '123',
                                title: `Вы уверены что хотите подписать ВСЕХ пользователей на эту тему рассылок?`,
                                icon: <ExclamationCircleOutlined />,
                                content: <span>{item.nazvanie}</span>,
                                okText: "Да",
                                okType: 'danger',
                                cancelText: "Нет",
                                onOk() {
                                    return new Promise((resolve, reject) => {
                                        GET(auth, `/api/rassilki/resign/${item.ID}`,
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data));
                                                resolve(data);
                                            }, (err) => errorCatch(err, reject));

                                    }).catch(() => { });
                                },
                                onCancel() {
                                },
                            })
                        },
                    },
                    {
                        title: <span style={{ color: "red" }}>Удалить</span>,
                        action: (values, unlock, close, { collection, setCollection }) => {
                            Modal.confirm({
                                title: `Вы уверены что хотите удалить тему рассылок?`,
                                icon: <ExclamationCircleOutlined />,
                                content: <span>{item.nazvanie}</span>,
                                okText: "Да",
                                okType: 'danger',
                                cancelText: "Нет",
                                onOk: () => {
                                    GET(auth, `/api/rassilki/delete/${item.ID}`,
                                        () => {
                                            setCollection(deleteInArray(collection, item))
                                        }, errorCatch
                                    );
                                },
                            });
                        },
                    }
                ]}
            />
        </div>
        </PageLayout>
    );
}
